var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.02 28.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #606060;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,14.77c.16-.48.28-.98.49-1.44.59-1.33,1.7-1.99,3.07-2.25.27-.05.39-.11.39-.42-.02-2.32-.06-4.65,0-6.97.05-1.73,1.14-3.22,2.95-3.52C7.6.06,8.32.01,9.03,0c8.15-.01,16.3-.01,24.45,0,1.07,0,2.11.18,3,.89.81.64,1.3,1.48,1.33,2.49.08,2.53.08,5.07.12,7.61l.07.07c1.84.19,3.36,1.4,3.76,3.22.16.74.23,1.51.25,2.27.04,1.37.02,2.73,0,4.1,0,.77-.24,1.44-1.02,1.74-.34.13-.72.15-1.12.23,0,1.29,0,2.61,0,3.93,0,1.19-.87,1.9-1.83,1.84-.42-.03-.85-.03-1.27,0-.91.08-1.7-.74-1.67-1.69.04-1.36.01-2.73.01-4.12H6.91c0,1.29,0,2.57,0,3.85,0,.29-.03.6-.11.88-.18.62-.83,1.07-1.49,1.08-.52,0-1.04-.01-1.56,0-.82.03-1.61-.69-1.6-1.59.02-1.37,0-2.73,0-4.16-1,.08-1.76-.26-2.15-1.23,0-2.22,0-4.43,0-6.65ZM38.07,26.74s.04-.05.07-.07v-4.02s-.04-.05-.07-.07h-1.45v4.16s0,.04,0,.06c.02-.02.04-.03.06-.05.46,0,.93-.01,1.39-.02ZM3.78,26.75h1.46v-4.17h-1.51c0,1.4,0,2.77,0,4.15,0,.02,0,.04-.01.06.02-.01.04-.03.06-.04ZM6.96,10.83c0-1.2.04-2.41,0-3.61-.03-1.05.67-1.75,1.74-1.74,3.21.02,6.43,0,9.64.02.35,0,.73.14,1.04.32.6.35.7.97.7,1.6.02,1.16,0,2.31,0,3.47h1.89c0-.17,0-.32,0-.47,0-1.18,0-2.35.02-3.53,0-.15.04-.32.1-.46.31-.69.88-.95,1.61-.95,3.21,0,6.43,0,9.64,0,.15,0,.3,0,.44.05.86.25,1.3.85,1.3,1.79,0,1.19,0,2.37,0,3.57h1.26c-.06-2.5-.09-4.98-.18-7.46-.02-.52-.27-.99-.77-1.33-.61-.41-1.26-.48-1.95-.48-8.27,0-16.54,0-24.81,0-.3,0-.6,0-.9.02-.87.07-1.61.41-1.94,1.25-.21.52-.29,1.11-.3,1.68-.03,2-.01,3.99-.01,5.99,0,.12.01.23.02.35h1.38s.04-.05.07-.07ZM40.12,16.97l.07-.07c0-.57.06-1.15,0-1.72-.09-.97-.45-1.78-1.42-2.23-.63-.29-1.28-.37-1.95-.37-9.61,0-19.22,0-28.84,0-1.32,0-2.65.01-3.97.07-.96.05-1.92.7-2.25,1.68-.29.85-.19,1.71-.2,2.57.02.02.05.04.07.07.11,0,.22.01.33.01,12.61,0,25.22,0,37.83,0,.11,0,.22,0,.33-.01ZM40.24,18.64H1.6v2.32h38.64v-2.32ZM33.46,7.11h-9.85v3.83h9.85v-3.83ZM8.71,7.11v3.83h9.83v-3.83h-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.99,11.07l-.07-.07.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.89,10.9s.04-.05.07-.07c-.02.02-.04.05-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.57,16.9l.07.07-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.12,16.97l.07-.07-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.13,22.65s-.04-.05-.07-.07c.02.02.04.05.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.07,26.74s.04-.05.07-.07c-.02.02-.04.05-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.73,26.73h.03s.02.02.02.02c-.02.01-.04.03-.06.04,0-.02,0-.04.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.62,26.74s.05-.01.06.01c-.02.02-.04.03-.06.05,0-.02,0-.04,0-.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDorm);
export default __webpack_public_path__ + "static/media/dorm.de827f448fb7d4ebbcad323c2d4e2cb3.svg";
export { ForwardRef as ReactComponent };